export enum ManagerPolicyPermissionTypes {
    Disabled = 1,
    PoliciesCreator = 2,
}
